import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DeletedAlumniPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const DeletedAlumniPage = () => {
  const [deletedAlumni, setDeletedAlumni] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const LIMIT = 10;

  const fetchDeletedAlumni = async (currentPage) => {
    try {
      setLoading(true);

      const { data } = await axios.get(
        `${API_BASE_URL}/deleted-alumni?page=${currentPage}&limit=${LIMIT}`
      );

      setDeletedAlumni(data.data);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error("Error fetching deleted alumni:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeletedAlumni(page);
  }, [page]);

  return (
    <div className="deleted-alumni-page">
      <h2>Deleted Alumni</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table className="deleted-alumni-table">
            <thead>
              <tr>
                <th>Alumni ID</th>
                <th>Full Name</th>
                <th>Mobile Numbers</th>
                <th>Deleted By</th>
                <th>Delete Date</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {deletedAlumni.length === 0 ? (
                <tr>
                  <td colSpan="6">No deleted alumni found.</td>
                </tr>
              ) : (
                deletedAlumni.map((alumni) => (
                  <tr key={alumni._id}>
                    <td>{alumni.alumniID}</td>
                    <td>
                      {alumni.title} {alumni.firstName} {alumni.middleName}{" "}
                      {alumni.lastName}
                    </td>
                    <td>{alumni.mobileNumbers?.join(", ")}</td>
                    <td>{alumni.deletedBy}</td>
                    <td>
                      {new Date(alumni.deleteDate).toLocaleDateString()}
                    </td>
                    <td>{alumni.reasons}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="pagination">
            <button
              disabled={page === 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              Previous
            </button>

            <span>
              Page {page} of {totalPages}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default DeletedAlumniPage;
